<template>
  <v-content>
    <v-container fluid fill-height grid-list-sm>
      <v-layout row wrap fill-height>
        <TabVerificaNote v-if="bottomNav === 'verify-nota'" :isGM="true"></TabVerificaNote>
        <TabReportMensileAdmin v-if="bottomNav === 'report-mese-admin'"></TabReportMensileAdmin>
        <TabPreautorizzato v-if="bottomNav === 'autorizzazioni'"></TabPreautorizzato>
      </v-layout>

      <loading :show="loading" :label="textProcess"></loading>
    </v-container>
      <v-bottom-nav :active.sync="bottomNav" class="primary" :value="true" fixed app>
        <v-btn value="verify-nota" class="tree--text">
          <span>Note</span>
          <v-badge :value="note.length > 0" color="purple" left overlap>
            <span slot="badge">{{note.length}}</span>
            <v-icon>list_alt</v-icon>
          </v-badge>
        </v-btn>
        <v-btn value="report-mese-admin" class="tree--text">
          <span>Report</span>
          <v-icon>list_alt</v-icon>
        </v-btn>
        <v-btn value="autorizzazioni" class="tree--text">
          <span>Autorizzazioni</span>
          <v-badge :value="richiestePerConfermare.length > 0" color="purple" left overlap>
            <span slot="badge">{{richiestePerConfermare.length}}</span>
            <v-icon>far fa-check-circle</v-icon>
          </v-badge>
        </v-btn>
      </v-bottom-nav>
  </v-content>
</template>

<script>
import { mapGetters, mapState, mapActions } from 'vuex'
import { GestioneAdmin } from "../stores";
import {
  TabVerificaNote,
  TabReportMensileAdmin,
  TabPreautorizzato,
  Loading
} from "../components";

export default {
  name: "p-gestione",
  components: {
    TabVerificaNote,
    TabReportMensileAdmin,
    TabPreautorizzato,
    Loading
  },
  data() {
    return {
      showBadge: true,
      bottomNav: "verify-nota"
    };
  },
  beforeCreate() {
    if (!this.$store.hasModule("gestione")) {
      this.$store.registerModule("gestione", GestioneAdmin);
    }
  },
  watch: {},
  computed: {
    ...mapGetters('gestione', ['richiestePerConfermare', 'note', 'loading', 'textProcess']),
    pageData() {
      return this.$store.getters.getPageData;
    },
  },
  created() {
    this.getNote();
    this.getRichieste();
    
    if (this.pageData.tab && ['verify-nota', 'report-mese-admin', 'autorizzazioni'].includes(this.pageData.tab)) {
      this.bottomNav = this.pageData.tab
    }
  },
  mounted() {},
  methods: {
    ...mapActions('gestione', ['getNote', 'getRichieste']),
  }
};
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style>
</style>



// WEBPACK FOOTER //
// modules/Home/views/src/pages/GestioneAdmin.vue